export default "__VITE_ASSET__NhmIBrXD__"